import { useEffect, useState } from "react";
import { createUseStyles } from "react-jss";
import { fetchApi } from "../services/api";
import { mediaDisplayUrl } from "./refresh/selectors/uploadedMedia";

const useStyles = createUseStyles({
  hotspot: {
    color: "white",
    position: "relative",
    width: "100%",
    marginBottom: 10,
    cursor: props => (props.hover ? "pointer" : "auto"),
    backgroundColor: "#313131",
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: props => (props.hover ? "#464646" : "#313131"),
    },
  },
  type: {
    textTransform: "uppercase",
    fontWeight: "bold",
    fontSize: 12,
    color: "#ccc",
    margin: 0,
  },
  tooltip: {
    margin: 0,
    fontSize: 18,
  },
  close: {
    transform: "rotate(45deg)",
    position: "absolute",
    top: 10,
    right: 18,
    cursor: "pointer",
    fontSize: 20,
    borderRadius: 50,
    height: 28,
    padding: [0, 8],
    transition: "background-color 0.1s ease",

    "&:hover": {
      backgroundColor: "#1a1a1a",
    },
  },
  icon: {
    width: 42,
    height: 42,
    float: "left",
    margin: [0, 10, 0, 0],
  },
});

const LinksPreview = ({ hotspot, remove, type, onClick }) => {
  const [icon, setIcon] = useState();
  const classes = useStyles({ hover: !!onClick });

  useEffect(() => {
    if (!hotspot.icon) return;

    const displayUrl = mediaDisplayUrl(hotspot.icon);
    if (displayUrl) {
      setIcon(displayUrl);
      return;
    }

    if (hotspot.icon.url) {
      setIcon(
        `${window.location.origin}/tour/assets/hotspots/${hotspot.icon.url}`,
      );
      return;
    }

    if (hotspot.icon.id) {
      fetchApi(`/media/${hotspot.icon.id}`, { version: "v2" })
        .then(data => setIcon(data.preview_url))
        .catch(e => console.error(e));
    }
    // Primitive fields only: a new icon object each render must not refetch.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    hotspot.icon?.id,
    hotspot.icon?.url,
    hotspot.icon?.preview_url,
    hotspot.icon?.public_url,
  ]);

  return (
    <div className={classes.hotspot} onClick={onClick}>
      {hotspot.icon && <img className={classes.icon} src={icon} alt="" />}
      <p className={classes.type}>
        {hotspot.type} {type}
      </p>
      <p className={classes.tooltip}>{hotspot.tooltip}</p>
      <span
        className={classes.close}
        onClick={evt => {
          evt.stopPropagation();
          if (
            window.confirm(
              type === "template"
                ? `Permanently delete template "${hotspot.tooltip}"?`
                : `Remove "${hotspot.tooltip}" from Links menu? The hotspot will be otherwise unaffected.`,
            )
          )
            remove();
        }}
      >
        +
      </span>
    </div>
  );
};

export default LinksPreview;
